// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Autofill styling */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus {
    -webkit-text-fill-color: #fff !important; /* White text to match the theme */
    -webkit-box-shadow: 0 0 0px 1000px none inset !important; /* Black background to match input */
    -webkit-transition: background-color 5000s ease-in-out 0s;
    transition: background-color 5000s ease-in-out 0s; /* Smooth color transition */
}

/* Default input styles */
input, textarea, select {
    background-color: transparent; /* Black background */
    color: #fff; /* White text */
    border: 1px solid #00ff00; /* Optional: green border */
    padding: 10px;
    outline: none;
    font-size: 16px;
}



.waitlist-container {
  position: relative;
  min-height: 100vh;
  max-height: 100vh;
  /* height: 100vh; */
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.background-video {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100vw;
  height: 100vh;
  transform: translate(-50%, -50%);
  object-fit: cover; /* Ensures the video fills the entire screen */
  z-index: -1;
}
.main-logo{
   height: 80px; 
   width: auto;
}
.content-box {
  position: relative;
  padding: 4rem 4rem;
  border-radius: 8px;
  width: 80%;
  height: 80%;
  text-align: center;
}

/* color="white"
                    style={{ fontFamily: "'Exo 2', sans-serif", fontWeight: "700" }} */

.site-title {
  font-family: "PPNeueMachina", sans-serif !important;
  font-weight: 600 !important;
  font-size: 6rem !important;
  color:#fff;
}
/* style={{ fontFamily: "'Exo 2', sans-serif", fontWeight: "400" }} */
.site-description{
  font-family: "PPNeueMachina", sans-serif !important;
  font-weight: 400 !important;
  font-size: 2rem !important;
}
.social-link {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 50px; /* Circle size */
  height: 50px;
  background-color: rgba(0, 0, 0, 0); /* Black background inside the circle */
  border: 2px solid white; /* White circular border */
  border-radius: 50%; /* Creates the circle */
  text-decoration: none; /* Removes link underline */
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.social-link img {
  width: 24px; /* Size of the icon */
  height: 24px;
  
}

.social-link:hover {
  transform: scale(1.1); /* Slight zoom effect */
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.7); /* Glow effect */
}
.form-container {
  padding: 20px;
  background: transparent;
  color: white;
}

.form-label {
  font-family: "PPNeueMachina", sans-serif !important;
  font-weight: bold;
  color: white;
  padding-top: 0px !important;
  margin-top: 0px !important;
  font-size: 1.6rem !important;
  text-align: right;
  padding-right: 8px;
}

.MuiOutlinedInput-root {
  background: black;
}

.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #fff;
}

.MuiOutlinedInput-notchedOutline {
  border-color: white;
}

.MuiButton-contained {
  transition: all 0.3s ease;
}

.MuiButton-contained:hover {
  background-color: #e6c200;
}
.invalid-button{
  background-color: #dfdfdf !important;
  font-family: "PPNeueMachina", sans-serif !important;
  color: #000 !important;
  border-radius: 8;
  padding: 8px 30px 4px 30px !important;
  font-weight: bold !important;
  font-size: 1.2rem !important;
}

.submit-button{
  background-color: #ffff00 !important;
  font-family: "PPNeueMachina", sans-serif !important;
  color: #000 !important;
  border-radius: 8;
  padding: 8px 30px 4px 30px !important;
  font-weight: bold !important;
  font-size: 1.2rem !important;
}

@media screen and (orientation: portrait) {
  .background-video {
    width: 100vh; /* Height becomes the width for rotation */
    height: 100vw; /* Width becomes the height for rotation */
    transform: translate(-50%, -50%) rotate(90deg);
  }
  .main-logo{
    height: 35px; 
    width: auto;
  }
  .social-link {
    width: 25px; /* Circle size */
    height: 25px;
  }
  
  .social-link img {
    width: 16px; /* Size of the icon */
    height: 16px;
    
  }

  .site-title {
    font-weight: 600 !important;
    font-size: 3rem !important;
  }

  .site-description{
    font-size: 1rem !important;
  }

  .form-label {
    font-family: "PPNeueMachina", sans-serif !important;
    font-weight: bold;
    color: white;
    text-align: center;
    padding-top: 0px !important;
    margin-top: 0px !important;
    font-size: 1rem !important;
  }

  .invalid-button{
    padding: 6px 15px 2px 15px !important;
    font-weight: bold !important;
    font-size: 1rem !important;
  }
  
  .submit-button{
    padding: 6px 15px 2px 15px !important;
    font-weight: bold !important;
    font-size: 1rem !important;
  }
  
}`, "",{"version":3,"sources":["webpack://./src/components/Waitlist.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;;;;;;IAMI,wCAAwC,EAAE,kCAAkC;IAC5E,wDAAwD,EAAE,oCAAoC;IAC9F,yDAAiD;IAAjD,iDAAiD,EAAE,4BAA4B;AACnF;;AAEA,yBAAyB;AACzB;IACI,6BAA6B,EAAE,qBAAqB;IACpD,WAAW,EAAE,eAAe;IAC5B,yBAAyB,EAAE,2BAA2B;IACtD,aAAa;IACb,aAAa;IACb,eAAe;AACnB;;;;AAIA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,iBAAiB,EAAE,8CAA8C;EACjE,WAAW;AACb;AACA;GACG,YAAY;GACZ,WAAW;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;sFACsF;;AAEtF;EACE,mDAAmD;EACnD,2BAA2B;EAC3B,0BAA0B;EAC1B,UAAU;AACZ;AACA,qEAAqE;AACrE;EACE,mDAAmD;EACnD,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW,EAAE,gBAAgB;EAC7B,YAAY;EACZ,kCAAkC,EAAE,uCAAuC;EAC3E,uBAAuB,EAAE,0BAA0B;EACnD,kBAAkB,EAAE,uBAAuB;EAC3C,qBAAqB,EAAE,2BAA2B;EAClD,mEAAmE;AACrE;;AAEA;EACE,WAAW,EAAE,qBAAqB;EAClC,YAAY;;AAEd;;AAEA;EACE,qBAAqB,EAAE,uBAAuB;EAC9C,6CAA6C,EAAE,gBAAgB;AACjE;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mDAAmD;EACnD,iBAAiB;EACjB,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,mDAAmD;EACnD,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,mDAAmD;EACnD,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE;IACE,YAAY,EAAE,0CAA0C;IACxD,aAAa,EAAE,0CAA0C;IACzD,8CAA8C;EAChD;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW,EAAE,gBAAgB;IAC7B,YAAY;EACd;;EAEA;IACE,WAAW,EAAE,qBAAqB;IAClC,YAAY;;EAEd;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mDAAmD;IACnD,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;IACrC,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;IACrC,4BAA4B;IAC5B,0BAA0B;EAC5B;;AAEF","sourcesContent":["/* Autofill styling */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus {\n    -webkit-text-fill-color: #fff !important; /* White text to match the theme */\n    -webkit-box-shadow: 0 0 0px 1000px none inset !important; /* Black background to match input */\n    transition: background-color 5000s ease-in-out 0s; /* Smooth color transition */\n}\n\n/* Default input styles */\ninput, textarea, select {\n    background-color: transparent; /* Black background */\n    color: #fff; /* White text */\n    border: 1px solid #00ff00; /* Optional: green border */\n    padding: 10px;\n    outline: none;\n    font-size: 16px;\n}\n\n\n\n.waitlist-container {\n  position: relative;\n  min-height: 100vh;\n  max-height: 100vh;\n  /* height: 100vh; */\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.background-video {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100vw;\n  height: 100vh;\n  transform: translate(-50%, -50%);\n  object-fit: cover; /* Ensures the video fills the entire screen */\n  z-index: -1;\n}\n.main-logo{\n   height: 80px; \n   width: auto;\n}\n.content-box {\n  position: relative;\n  padding: 4rem 4rem;\n  border-radius: 8px;\n  width: 80%;\n  height: 80%;\n  text-align: center;\n}\n\n/* color=\"white\"\n                    style={{ fontFamily: \"'Exo 2', sans-serif\", fontWeight: \"700\" }} */\n\n.site-title {\n  font-family: \"PPNeueMachina\", sans-serif !important;\n  font-weight: 600 !important;\n  font-size: 6rem !important;\n  color:#fff;\n}\n/* style={{ fontFamily: \"'Exo 2', sans-serif\", fontWeight: \"400\" }} */\n.site-description{\n  font-family: \"PPNeueMachina\", sans-serif !important;\n  font-weight: 400 !important;\n  font-size: 2rem !important;\n}\n.social-link {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 50px; /* Circle size */\n  height: 50px;\n  background-color: rgba(0, 0, 0, 0); /* Black background inside the circle */\n  border: 2px solid white; /* White circular border */\n  border-radius: 50%; /* Creates the circle */\n  text-decoration: none; /* Removes link underline */\n  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n}\n\n.social-link img {\n  width: 24px; /* Size of the icon */\n  height: 24px;\n  \n}\n\n.social-link:hover {\n  transform: scale(1.1); /* Slight zoom effect */\n  box-shadow: 0 0 10px rgba(255, 255, 255, 0.7); /* Glow effect */\n}\n.form-container {\n  padding: 20px;\n  background: transparent;\n  color: white;\n}\n\n.form-label {\n  font-family: \"PPNeueMachina\", sans-serif !important;\n  font-weight: bold;\n  color: white;\n  padding-top: 0px !important;\n  margin-top: 0px !important;\n  font-size: 1.6rem !important;\n  text-align: right;\n  padding-right: 8px;\n}\n\n.MuiOutlinedInput-root {\n  background: black;\n}\n\n.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #fff;\n}\n\n.MuiOutlinedInput-notchedOutline {\n  border-color: white;\n}\n\n.MuiButton-contained {\n  transition: all 0.3s ease;\n}\n\n.MuiButton-contained:hover {\n  background-color: #e6c200;\n}\n.invalid-button{\n  background-color: #dfdfdf !important;\n  font-family: \"PPNeueMachina\", sans-serif !important;\n  color: #000 !important;\n  border-radius: 8;\n  padding: 8px 30px 4px 30px !important;\n  font-weight: bold !important;\n  font-size: 1.2rem !important;\n}\n\n.submit-button{\n  background-color: #ffff00 !important;\n  font-family: \"PPNeueMachina\", sans-serif !important;\n  color: #000 !important;\n  border-radius: 8;\n  padding: 8px 30px 4px 30px !important;\n  font-weight: bold !important;\n  font-size: 1.2rem !important;\n}\n\n@media screen and (orientation: portrait) {\n  .background-video {\n    width: 100vh; /* Height becomes the width for rotation */\n    height: 100vw; /* Width becomes the height for rotation */\n    transform: translate(-50%, -50%) rotate(90deg);\n  }\n  .main-logo{\n    height: 35px; \n    width: auto;\n  }\n  .social-link {\n    width: 25px; /* Circle size */\n    height: 25px;\n  }\n  \n  .social-link img {\n    width: 16px; /* Size of the icon */\n    height: 16px;\n    \n  }\n\n  .site-title {\n    font-weight: 600 !important;\n    font-size: 3rem !important;\n  }\n\n  .site-description{\n    font-size: 1rem !important;\n  }\n\n  .form-label {\n    font-family: \"PPNeueMachina\", sans-serif !important;\n    font-weight: bold;\n    color: white;\n    text-align: center;\n    padding-top: 0px !important;\n    margin-top: 0px !important;\n    font-size: 1rem !important;\n  }\n\n  .invalid-button{\n    padding: 6px 15px 2px 15px !important;\n    font-weight: bold !important;\n    font-size: 1rem !important;\n  }\n  \n  .submit-button{\n    padding: 6px 15px 2px 15px !important;\n    font-weight: bold !important;\n    font-size: 1rem !important;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
